
import axios, { AxiosResponse } from "axios"
import { config } from "@/config"
import { TransformationTemplate } from "@/types/WorkflowCreate/transformation"

export const TransformationAPI = {
  getTemplates: async (token: string) => {
    try {
      const resp: AxiosResponse<TransformationTemplate[]> = await axios({
        method: 'GET',
        url: `${config.apiUrl}/v1/transformation-steps/templates`,
        headers: {
          Authorization: `Bearer ${token}`
        },
      })

      return { data: resp.data, err: undefined }
    } catch (error) {
      console.log('Error: ', error instanceof Error ? error.message : error)
      return { data: undefined, err: 'Unable to fetch transformation templates' }
    }
  },
}
